import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "./My_Table.css";
import Select from "react-select";
import { Table, Button, Form } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import {
  deleteData,
  editStatusData,
  getData,
  getDownloadDataExcel,
  postData,
} from "../../../../utils/api";
import { Link } from "react-router-dom";
import { ApprovalStatus, RoleId, Select2Data } from "../../../../utils/common";
import LinkProductsModel from "../LinkProductsModel";
import { DeletButton } from "../../../common/Button";
import ModalDelete from "../../../common/ModelDelete";
import search1 from "../../../assets/icons/search.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
function My_Table({
  data,
  getDataAll,
  user,
  reset,
  setonPageChange,
  setChangeStatus,
  setReset,
  childCategories,
  subCategories,
  categories,
  setSearchCategory,
  setSearchSubCategory,
  setSearchChildCategory,
  searchChildCategory,
  searchSubCategory,
  searchCategory,
  getAllSubCategories,
  getAllChildCategories,
  setSearch,
  search,
  searchDateTo,
  searchDateFrom,
  setSearchDateTo,
  setSearchDateFrom,
  setSubCategories,
  setChildCategories,
  HandleDownload,
  Sample,
  BulkUpload,
  GetEditData,
  uploadStatus,
  uploadLoading,
}) {
  const { IMG_URL, ErrorNotify } = useContext(Context);

  const [showModel, setShowModel] = useState(0);

  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/admin/products/${recordToDeleteId}`);
      if (response?.success) {
        getDataAll();
      }

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/admin/products/${id}`);
    setChangeStatus(response);
  };

  const ChangeStatusEight = async (id) => {
    const response = await editStatusData(
      `/admin/products/eight-plus-status/${id}`
    );
    setChangeStatus(response);
  };

  const ChangeSeasonable = async (id) => {
    const response = await editStatusData(
      `/admin/products/seasonable-status/${id}`
    );
    setChangeStatus(response);
  };

  const ChangePopular = async (id) => {
    const response = await editStatusData(
      `/admin/products/popular-status/${id}`
    );
    setChangeStatus(response);
  };

  const [sortBy, setSortBy] = useState("orders");
  const [sortOrder, setSortOrder] = useState("asc");

  const sortedData = [...(data?.data?.data || [])].sort((a, b) => {
    const totalA = a?.Product_Order_Details?.reduce(
      (sum, detail) => sum + parseFloat(detail?.total_amount || 0),
      0
    );

    const totalB = b?.Product_Order_Details?.reduce(
      (sum, detail) => sum + parseFloat(detail?.total_amount || 0),
      0
    );

    if (sortBy === "price") {
      return sortOrder === "asc" ? totalA - totalB : totalB - totalA;
    } else {
      // fallback: sort by order count
      const countA = a?.Product_Order_Details?.length || 0;
      const countB = b?.Product_Order_Details?.length || 0;
      return sortOrder === "asc" ? countA - countB : countB - countA;
    }
  });

  const ChangeUploadStatus = async () => {
    const response = await editStatusData(`/admin/products/upload-status`);
    GetEditData();
  };
  return (
    <section className="pending-table_holder">
      {/* Quick Filters Section */}
      <div className="quick-filters mt-3">
        <span className="quick-filters__label">
          <b>Quick Filters:</b>
        </span>
        <div className="quick-filters__tabs mt-3">
          <div className="row">
            <div className="col-lg-3 mb-2">
              <Form.Label>Product Name</Form.Label>
              <Form.Control
                placeholder="Enter Product Name"
                type="text"
                className="form-control"
                id=""
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </div>

            <div className="col-lg-3 mb-2">
              <Form.Label>Select Category </Form.Label>
              <Select
                isSearchable
                options={categories}
                value={searchCategory}
                placeholder="Select Category"
                onChange={(e) => {
                  setSearchCategory(e);
                  getAllSubCategories(e.value);
                  setChildCategories("");
                  setSubCategories("");
                  setSearchSubCategory("");
                  setSearchChildCategory("");
                }}
                classNamePrefix="searchProduct"
              />
            </div>

            <div className="col-lg-3 mb-2">
              <Form.Label>Select Sub Category </Form.Label>
              <Select
                isSearchable
                options={subCategories}
                value={searchSubCategory}
                placeholder="Select Sub Category"
                onChange={(e) => {
                  setSearchSubCategory(e);
                  setSearchChildCategory("");
                  setSubCategories("");
                  getAllChildCategories(e.value);
                }}
                classNamePrefix="searchProduct"
              />
            </div>

            <div className="col-lg-3 mb-2">
              <Form.Label>Select Child Category </Form.Label>
              <Select
                isSearchable
                options={childCategories}
                value={searchChildCategory}
                placeholder="Select Child Category"
                onChange={(e) => {
                  setSearchChildCategory(e);
                }}
                classNamePrefix="searchProduct"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row align-items-end mb-3">
        <div className="col-12 mb-2">
          <div className="row">
            <div className="col-md-3">
              <div className="num me-2">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="from"
                  value={searchDateFrom}
                  onChange={(e) => {
                    setSearchDateFrom(e.target.value);
                    setonPageChange(1);
                  }}
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="num me-2">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="to"
                  value={searchDateTo}
                  onChange={(e) => {
                    setSearchDateTo(e.target.value);
                    setonPageChange(1);
                  }}
                />
              </div>
            </div>
            <div className="col-xxl-1 col-xl-1  col-lg-1 col-md-1">
              <div className="Search me-2">
                <Button
                  type="button"
                  onClick={getDataAll}
                  className="btn btn-search"
                >
                  <img src={search1} className="search" alt="" />
                </Button>
              </div>
            </div>
            <div className="col-xxl-1 col-xl-1  col-lg-2 col-md-2">
              <div className="Search-1">
                <button
                  type="button"
                  onClick={() => {
                    setSearch("");
                    setSearchDateFrom("");
                    setSearchDateTo("");
                    setSearchCategory("");
                    setSearchChildCategory("");
                    setSearchSubCategory("");
                    setReset(!reset);
                  }}
                  className="btn btn-reset"
                >
                  Reset
                </button>
              </div>
            </div>
            {/* <div className=" col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
              <Form.Label> Download Excel</Form.Label>
              <div>
                <button
                  className="btn btn-success mt-2"
                  type="button"
                  onClick={HandleDownload}
                >
                  Product Wise Loss
                  <FontAwesomeIcon
                    icon="fa-solid fa-file-lines"
                    className="ms-2"
                  />
                </button>
              </div>
            </div> */}

            <div className="col-lg-3 mb-2">
              <Form.Label>Sort According </Form.Label>
              <Select
                options={[
                  { label: "Order Count", value: "orders" },
                  { label: "Total Price", value: "price" },
                ]}
                value={{
                  label: sortBy === "orders" ? "Order Count" : "Total Price",
                  value: sortBy,
                }}
                onChange={(e) => setSortBy(e.value)}
                placeholder="Sort By"
              />
            </div>

            <div className="col-lg-3 mb-2">
              <Form.Label>Order </Form.Label>
              <Select
                options={[
                  { label: "Ascending", value: "asc" },
                  { label: "Descending", value: "desc" },
                ]}
                value={{
                  label: sortOrder === "asc" ? "Ascending" : "Descending",
                  value: sortOrder,
                }}
                onChange={(e) => setSortOrder(e.value)}
                placeholder="Sort Product"
              />
            </div>

            <div className=" col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
              <Form.Label></Form.Label>
              <div>
                <button
                  className="btn btn-success mt-2"
                  type="button"
                  onClick={HandleDownload}
                >
                  Download Excel
                  <FontAwesomeIcon
                    icon="fa-solid fa-file-lines"
                    className="ms-2"
                  />
                </button>
              </div>
            </div>
            <div className=" col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
              <Link type="button" className="btn btn-add pe-3">
                <div onClick={Sample}>Sample</div>
              </Link>
            </div>

            {/* <div className=" col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
              {uploadLoading ? (
                <>
                  {" "}
                  <button
                    className="btn btn-add pe-3"
                    // onClick={() =>
                    //   document.getElementById("CategoryFile").click()
                    // }
                  >
                   uploading
                  </button>
                  <input
                    type="file"
                    id="CategoryFile"
                    onChange={(e) => {
                      BulkUpload(e);
                    }}
                    accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    style={{ display: "none" }}
                  />
                </>
              ) : (
                <>
                  {" "}
                  <button
                    className="btn btn-add pe-3"
                    onClick={() =>
                      document.getElementById("CategoryFile").click()
                    }
                  >
                    Bulk Upload
                  </button>
                  <input
                    type="file"
                    id="CategoryFile"
                    onChange={(e) => {
                      BulkUpload(e);
                    }}
                    accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    style={{ display: "none" }}
                  />
                </>
              )}
            </div> */}

            <div className="col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
              {/* 1️⃣ Uploading */}
              {uploadLoading && (
                <button className="btn btn-add pe-3" disabled>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Uploading...
                </button>
              )}

              {/* 2️⃣ Upload Success */}
              {!uploadLoading && uploadStatus === false && (
                <button className="btn btn-success pe-3" disabled>
                  Uploaded
                </button>
              )}

              {/* 3️⃣ Default */}
              {!uploadLoading && uploadStatus && (
                <>
                  <button
                    className="btn btn-add pe-3"
                    onClick={() =>
                      document.getElementById("CategoryFile").click()
                    }
                    disabled={uploadLoading}
                  >
                    Bulk Upload
                  </button>

                  <input
                    type="file"
                    id="CategoryFile"
                    onChange={BulkUpload}
                    accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    style={{ display: "none" }}
                    disabled={uploadLoading}
                  />
                </>
              )}
            </div>

            {/* <div className=" col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
              <label className="upload-btn">
                <input
                  type="file"
                  accept=".xlsx,.csv"
                  hidden
                  onChange={BulkUpload}
                  disabled={uploadLoading}
                />

                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={uploadLoading}
                >
                  {uploadLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Uploading...
                    </>
                  ) : (
                    "Bulk Upload"
                  )}
                </button>
              </label>
            </div> */}

            <div className=" col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
              <Form.Label></Form.Label>
              <div>
                <button
                  className="btn btn-success mt-2"
                  type="button"
                  onClick={ChangeUploadStatus}
                >
                  {uploadStatus
                    ? " Exchang New Price"
                    : " Upload old Price"}

                  {/* <FontAwesomeIcon
                    icon="fa-solid fa-file-lines"
                    className="ms-2"
                  /> */}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="pending-table ">
        <Table striped bordered hover className="order-table" responsive>
          <thead>
            <tr>
              <th>Creation Date</th>
              <th>Product details</th>
              {/* <th>Store details</th> */}
              <th>Image</th>
              <th>Categories</th>
              <th>Total Order</th>
              <th>Sort Product</th>
              <th>Tax Percentage</th>

              {/* {user && user?.role_id === RoleId.Vendor && */}
              <th>Status</th>
              {/* } */}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {sortedData?.map((item, index) => (
              <tr key={index}>
                <td className="order-date">
                  <div className="order-id">
                    {calculateTimeAgo(item?.createdAt)}
                  </div>
                  <div className="order-info">
                    <span>
                      {new Date(item?.createdAt).toISOString().split("T")[0]}
                    </span>
                  </div>
                  <div className="order-info">
                    <span>{formatTimeInIST(item?.createdAt)} IST</span>
                  </div>
                </td>

                {/* Owner Details */}
                <td className="order-details">
                  <div className="order-id text-highlight">
                    {item?.item_code}
                  </div>
                  <div className="order-info">
                    <span className="text-highlight">{item?.name}</span>
                  </div>
                  {/* <div className="order-info">
                    <span>{item?.price} / {item?.Unit?.name}</span>
                  </div> */}
                  <div className="order-info">
                    <div className="order-id">Brand</div>
                    <span>{item?.Brand?.name}</span>
                  </div>
                  <div className="order-info">
                    <div className="order-id">Manufacturer</div>
                    <span>{item?.manufacturer} </span>
                  </div>
                </td>

                {/* Store Details */}
                {/* <td className="order-details">
                  <div className="order-info">
                    <span className="text-highlight">{item?.Store_Detail?.store_name}</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.Store_Detail?.website}</span>
                  </div>
                </td> */}

                <td>
                  <img
                    src={IMG_URL + item?.image}
                    alt="Product"
                    className="product-image"
                  />
                </td>

                <td className="order-details">
                  {/* <div className="order-info">
                    <span className="text-highlight">{item?.Store_Detail?.store_name}</span>
                  </div> */}
                  <div className="order-info">
                    <span>{item?.p_category?.name}</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.p_sub_category?.name} </span>
                  </div>
                  <div className="order-info">
                    <span>{item?.p_child_category?.name} </span>
                  </div>
                  {/* <div className="order-info">
                    <div className="order-id">Manufacturer:</div>
                    <span>{item?.manufacturer} </span>
                  </div> */}
                </td>

                <td>
                  <div className="order-info">
                    <span>
                      {" "}
                      No Of order {item?.Product_Order_Details?.length}{" "}
                    </span>
                  </div>
                  <div className="order-info">
                    <span>
                      Total Price: ₹
                      {item?.Product_Order_Details?.reduce((sum, detail) => {
                        return sum + parseFloat(detail?.total_amount || 0);
                      }, 0).toFixed(2)}
                    </span>
                  </div>
                </td>
                <td>{item?.sort_order}</td>

                <td>
                  <div className="order-info">
                    {/*<span>{item?.description} </span>*/}
                    {item?.tax_percentage && (
                      <>
                        {/* <div className="order-id">Tax</div> */}
                        <span>{item?.tax_percentage} % </span>
                      </>
                    )}
                  </div>
                </td>

                {/* <td>
                  {item?.Often_Ordered_Withs?.map((item) => (
                    <div key={item?.id} className="order-info">
                      <span className="text-highlight"> {item?.linked_product?.name}</span>
                    </div>
                  ))}

                  
                  <Button
                    className="action-btn my-1"
                    onClick={() =>
                      setShowModel(item?.id)
                    }
                    style={{ marginTop: "auto" }}
                  >
                    Edit
                  </Button>
                

                </td> */}

                {/* {user && user?.role_id === RoleId.Vendor && */}
                <td>
                  {/* Status */}
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={item?.status}
                      onChange={() => ChangeStatus(item?.id)}
                      id={`statusSwitch${item?.id}`}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`statusSwitch${item?.id}`}
                    >
                      {item?.status ? "Active" : "Inactive"}
                    </label>
                  </div>

                  {/* Eighteen Plus Status */}
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={item?.eight_plus_status}
                      onChange={() => ChangeStatusEight(item?.id)}
                      id={`eightPlusSwitch${item?.id}`}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`eightPlusSwitch${item?.id}`}
                    >
                      {item?.eight_plus_status
                        ? "Eighteen Plus Active"
                        : "Eighteen Plus Inactive"}
                    </label>
                  </div>

                  {/* New In Product */}
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={item?.seasonable_status}
                      onChange={() => ChangeSeasonable(item?.id)}
                      id={`seasonableSwitch${item?.id}`}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`seasonableSwitch${item?.id}`}
                    >
                      New In Product ?
                    </label>
                  </div>

                  {/* Popular Product */}
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={item?.popular_status}
                      onChange={() => ChangePopular(item?.id)}
                      id={`popularSwitch${item?.id}`}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`popularSwitch${item?.id}`}
                    >
                      Popular Product ?
                    </label>
                  </div>
                </td>

                {/* } */}

                <td>
                  {/* {user && user?.role_id === RoleId.Admin &&
                    <select
                      className={item?.approval_status_id === ApprovalStatus.Approved ? "status-holder shipped" : "status-holder Unshipped"}
                      onChange={(e) => ChangeStoreStatus(item?.id, e.target.value)}
                      value={item?.Approval_Status?.id}
                    >
                      <option value={ApprovalStatus.Pending}>Inactive</option>
                      <option value={ApprovalStatus.Approved}>Approved</option>
                      <option value={ApprovalStatus.Rejected}>Rejected</option>
                    </select>
                  } */}

                  {/* {user && user?.role_id === RoleId.Vendor && */}
                  <div className="my-1">
                    <Link to={`/product/edit/${item?.id}`}>
                      <Button className="action-btn active">Edit</Button>
                    </Link>
                    <div className="my-1">
                      <Button
                        className="action-btn "
                        onClick={() => showDeleteRecord(item?.id, item?.name)}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                  {/* } */}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <LinkProductsModel
        user={user}
        show={showModel}
        handleClose={() => {
          setShowModel(0);
          getDataAll();
        }}
      />
      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />
    </section>
  );
}

export default My_Table;
